import React from 'react';
import { Link } from 'react-router-dom';

const BlockSummary = ({ pagetype, store }) => {
  let shipordeliver = store.getState().selectedorderdata.shipordeliverdata;
  let shippingcurrent = store.getState().selectedorderdata.shippingdata;
  let pickupcurrent = store.getState().selectedorderdata.pickupdata;
  let paymentcurrent = store.getState().selectedorderdata.paymentdata;
  let addresscurrent = store.getState().addressdatacurrent.addressData;
  let localuserdata = store.getState().checkoutcontext?.checkoutcontextall?.checkoutcontextselect?.select_userdata?.email || '';
  const checkoutsteps = store.getState().checkoutsettings.checkoutSettings.checkout_steps;

  console.log("The local user here: ",localuserdata);

  const renderPickupMethodSection = () => {
    return (
      <>
      <hr className="my-0 mx-2" />
        <div className="row g-3 pt-4 pb-4 ps-2 mb-0">
          <div className="col-2">Methode:</div>
          <div className="col-8">
            {pickupcurrent && (
              <>
                Abholung vor Ort: {' '}
                {pickupcurrent.locationname && `${pickupcurrent.locationname}, `}
              </>
            )}
          </div>
          <div className="col-2">
            <Link to="/">Ändern</Link>
          </div>
        </div>
      </>
    );
  };

  const renderShippingMethodSection = () => {
    return (
      <>
        <hr className="my-0 mx-2" />
        <div className="row g-3 pt-4 pb-4 ps-2 mb-0">
          <div className="col-2">Methode:</div>
          <div className="col-8">{shippingcurrent && shippingcurrent.title}</div>
          <div className="col-2">
            <Link to="/ips-shipping">Ändern</Link>
          </div>
        </div>
      </>
    );
  };

  const renderPaymentMethodSection = () => {
    return (
      <>
        <hr className="my-0 mx-2" />
        <div className="row g-3 pt-4 pb-4 ps-2 mb-0">
          <div className="col-2">Zahlung:</div>
          <div className="col-8">{paymentcurrent && paymentcurrent.title}</div>
          <div className="col-2">
            <Link to="/ips-payment">Ändern</Link>
          </div>
        </div>
      </>
    );
  };

  const renderAddressSection = () => {
    return (
      <>
        <hr className="my-0 mx-2" />
        <div className="row g-3 pt-4 pb-4 ps-2 mb-0">
          <div className="col-2">Versand nach:</div>
          <div className="col-8">
            {addresscurrent && (
              <>
                {addresscurrent.companyName && `${addresscurrent.companyName}, `}
                {addresscurrent.firstName && `${addresscurrent.firstName} `}
                {addresscurrent.lastName && `${addresscurrent.lastName}, `}
                {addresscurrent.street && `${addresscurrent.street} `}
                {addresscurrent.houseNumber && `${addresscurrent.houseNumber}, `}
                {addresscurrent.zip && `${addresscurrent.zip} `}
                {addresscurrent.city && `${addresscurrent.city}, `}
              </>
            )}
          </div>
          <div className="col-2">
            <Link to="/">Ändern</Link>
          </div>
        </div>
      </>
    );
  };

  

  return (
    <div id="ips-checkout-summary-details" className="ips-module">
      <div className="row g-3">
        <div className="col-12">
          <div className="border border-1 pt-4 pb-0 my-4 rounded">
            <div className="row g-3 mb-4 ps-2">
              <div className="col-2">Kontakt:</div>
              <div className="col-8">{localuserdata || 'Keine E-Mail angegeben'}</div>
              <div className="col-2">
                <Link to="/change-contact">Ändern</Link>
              </div>
            </div>
            {/*<hr className="my-0 mx-1" />*/}
            {shipordeliver === 'delivery' && renderAddressSection()}
            {shipordeliver === 'pickup' && renderPickupMethodSection()}
            {checkoutsteps === 'select2' && renderShippingMethodSection()}
            {checkoutsteps === 'select3' && pagetype === 'payment' && renderShippingMethodSection()}
            {checkoutsteps === 'select3' && pagetype === 'review' && (
              <>
                {renderShippingMethodSection()}
                {renderPaymentMethodSection()}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockSummary;